module.exports = __webpack_public_path__ + "img/colosus.863fd0d6.png";